import { createFileRoute, Link, redirect } from '@tanstack/react-router';
import { sessionQueryOptions } from '@/lib/auth-query-options';
import { listOrgsQueryOptions } from '@/lib/org-query-options';

export const Route = createFileRoute('/')({
  ssr: 'data-only',
  beforeLoad: async ({ context: { queryClient } }) => {
    const session = await queryClient.ensureQueryData(sessionQueryOptions);
    if (!session) return;

    const orgs = await queryClient.ensureQueryData(listOrgsQueryOptions);
    const resolvedOrg = orgs.find((o) => o.id === session.session?.activeOrganizationId) ?? orgs[0] ?? null;

    if (!resolvedOrg) {
      throw redirect({ to: '/onboarding' });
    }

    throw redirect({
      to: '/$orgSlug/repositories',
      params: { orgSlug: resolvedOrg.slug },
    });
  },
  component: Home,
});

function Home() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Top green stripe */}
      <div className="h-2 bg-mesa-green" />

      {/* Content */}
      <div className="flex-1 flex flex-col items-center justify-center gap-4">
        <h1 className="text-4xl font-bold text-mesa-text tracking-tight">Mesa</h1>
        <p className="text-mesa-muted">Git hosting for your team</p>
        <Link
          to="/sign-in"
          className="bg-mesa-green px-4 py-2 text-sm font-semibold text-white hover:bg-mesa-green-dark transition-colors"
        >
          Sign in
        </Link>
      </div>

      {/* Bottom green stripe */}
      <div className="h-2 bg-mesa-green" />
    </div>
  );
}
